<template>
  <a-layout>
    <a-layout-header>
      <Header :is-menu="true" :is-login="true" @menuClick="changeCollapsed" />
    </a-layout-header>
    <a-layout>
      <div class="custom-mask" />
      <Message />
      <a-layout-sider
        v-model="collapsed"
        theme="light"
        breakpoint="md"
        :collapsed-width="collapsedWidth"
        :collapsible="collapsible"
        :class="{ collapsedOpen: !collapsed }"
        @collapse="collapse"
        @breakpoint="breakpoint"
      >
        <Sidebar ref="sidebar" @routeWatch="routeWatch" />
      </a-layout-sider>
      <a-layout-content>
        <transition name="component-fade" mode="out-in">
          <div>
            <Breadcrumb />
            <router-view />
          </div>
        </transition>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import Header from '@GC/Header.vue'
import Sidebar from '@GC/Sidebar.vue'
import Message from '@GC/Message.vue'
import XO9ActiveFeature from '@G/mixins/XO9ActiveFeature'
export default {
  name: 'Home',
  components: {
    Header,
    Sidebar,
    Message
  },
  mixins: [XO9ActiveFeature],
  data() {
    return {
      collapsible: true, // 是否可收起
      collapsed: false, // 当前收起状态
      trigger: true, // 自定义 trigger，设置为 null 时隐藏 trigger
      collapsedWidth: 80 // 收缩宽度，设置为 默認 80
    }
  },

  watch: {
    collapsed() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        if (!this.collapsed) {
          //代表打開
          document.body.classList.add('collapsedOpen')
          window.scrollTo(0, 0)
          document.body.addEventListener('click', this.outside_menu_click)
        } else {
          document.body.classList.remove('collapsedOpen')
          document.body.removeEventListener('click', this.outside_menu_click)
        }
      }
    }
  },
  async created() {
    // 針對刷新頁面時不會觸發 API 的頁面，打一次 API，檢查系統維護狀態
    const appName = process.env.VUE_APP_FOLDER_NAME
    const apiProvider =
      appName === 'XNB_XO'
        ? this.$operatorGraphqlProvider
        : this.$departmentGraphqlProvider
    await apiProvider.getSystemInfo()
  },
  methods: {
    outside_menu_click(event) {
      let e = event.target
      if (
        typeof e.className === 'string' &&
        e.className.indexOf('custom-mask') > -1
      )
        this.collapsed = true //一律關掉collapsed
    },
    changeCollapsed() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.collapsed = !this.collapsed
      }
    },
    routeWatch() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.collapsed = true //一律關掉collapsed
      }
    },
    collapse(collapsed) {
      collapsed && this.$refs.sidebar.resetOpenKeys()
    },
    breakpoint(broken) {
      broken && (this.collapsedWidth = 0)
      broken || (this.collapsedWidth = 80)
    }
  }
}
</script>
